import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  AppSettings,
  ICustomerPaymentInfo,
  PaymentAfterSave,
  PaymentBeforeSave,
  PaymentError,
  PaymentMethodService,
  CustomerPaymentInfoService,
} from 'pac-api';
import { Subject, BehaviorSubject, Observable, of } from 'rxjs';
import { map, switchMap, tap, catchError } from 'rxjs/operators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ShoppingCartService } from 'lms-api';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CheckoutException } from 'lms-api';
import { Router } from '@angular/router';
import { UserInvoiceService } from '../_services/user-invoice.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {
  public CustomerPaymentInfo$: Observable<ICustomerPaymentInfo[]>;

  @Output()
  public Dismiss: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public Update: EventEmitter<ICustomerPaymentInfo> = new EventEmitter<ICustomerPaymentInfo>();

  public Action: 'Insert' | 'Update';

  public Busy$: Subject<boolean> = new BehaviorSubject(false);

  public PaymentMethods$: Observable<any[]>;

  public FormAction: 'select' | 'add';

  private subsink: SubSink = new SubSink();

  public checkoutForm: UntypedFormGroup;

  public CheckoutProcessing: boolean = false;
  public CheckoutError: boolean = false;
  public PaymentInfoError: string;

  constructor(
    private paymentMethodService: PaymentMethodService,
    private paymentService: CustomerPaymentInfoService,
    public cartService: ShoppingCartService,
    private Settings: AppSettings,
    private modal: NgbActiveModal,
    private router: Router,
    private invoiceService: UserInvoiceService
  ) { }

  public ngOnInit(): void {
    this.FormAction = 'add';
    this.checkoutForm = new UntypedFormGroup({});
    this.checkoutForm.addControl('cpi', new UntypedFormControl('0: null', Validators.required));

    //this.Action = this.CustomerPaymentInfo.cpi_key ? 'Update' : 'Insert';
    this.PaymentMethods$ = this.paymentMethodService.Get().pipe(
      map(methods => {
        return methods.filter(apm => apm.asn_code === this.Settings.pac_base_asn_code);
      })
    );

    this.CustomerPaymentInfo$ = this.paymentService.Get();
    this.CustomerPaymentInfo$.subscribe(cpi => {
      if (cpi.length > 0) this.FormAction = 'select';
    });
  }

  public SwitchFormAction() {
    this.FormAction = this.FormAction == 'select' ? 'add' : 'select';
  }

  public ngOnDestroy(): void {
    if (this.subsink) {
      this.subsink.unsubscribe();
    }
  }

  public ngAfterViewInit(): void {
  }


  public OnBeforeSave(event: PaymentBeforeSave): void {
    this.PaymentInfoError = null;
  }

  public OnAfterSave(event: PaymentAfterSave): void {
    this.Update.emit(event.cpi);
    this.PaymentInfoError = null;
    this.FormAction = 'select';
  }

  public OnError(event: PaymentError): void {
    this.PaymentInfoError = "An error occurred while saving your payment info: " + event.error.message;
  }

  public CloseCheckoutModal() {
    this.modal.close();
  }

  public DoCheckout() {
    this.CheckoutProcessing = true;
    this.CheckoutError = false;
    return this.CustomerPaymentInfo$.pipe(
      map((allCPI: ICustomerPaymentInfo[]) => {
        let trxCPI = allCPI.find(cpi => cpi.cpi_key == this.checkoutForm.get("cpi").value);
        return trxCPI;
      }),
      switchMap((trxCPI: ICustomerPaymentInfo) => {
        return this.cartService.SetPayment(trxCPI.cpi_key, trxCPI.apm_key);
      }),
      switchMap(paymentResult => {
        return this.cartService.Checkout();
      })
    ).pipe(
      catchError(err => {
        this.CheckoutError = true;
        this.CheckoutProcessing = false;
        return of(err);
      }),
      tap(result => {
        if (!(result instanceof Error)) {
          this.cartService.RefreshCart().subscribe(cart => {
            this.CloseCheckoutModal();
            this.CheckoutProcessing = false;
            this.invoiceService.Refresh();
            this.router.navigateByUrl('myaccount');
          });
        }
      })
    ).subscribe();
  }

}
